<template>
  <div class="m-main">
    <div class="m-main-bg">
      <div class="descript">
        <div class="fs-50">助力高中</div>
        <div class="fs-50 padding-left">成就梦想</div>
        <div class="fs-20">
          本软件系统是湖北省技术创新专项重大项目“面向教育协同治理的高考按专业招考服务系统研发与应用示范”(No.2018ACA133)的原型系统。项目立足于按专业招考改革过程中所面临的难点问题，深入研究相关关键技术，为湖北省的考生、家长、中学以及高校提供个性化服务和参考，为湖北省新高考政策落地提供智力支撑、技术保障、应用示范。
        </div>
      </div>
      <div class="m-main-bg-img">
        <Map></Map>
        <!-- <img src="../../assets/img/17781638195078_.pic_hd.jpg" alt="" /> -->
      </div>
    </div>
    <div class="card-contain">
      <div v-for="(item, i) in cardData" :key="i" class="card-contain__item" @click="goToFn(item.url)">
        <div class="title">{{ item.title }}</div>
        <div class="img"><img :src="item.imgsrc" /></div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
    <!-- <div @click="goToFn('/m-index/hld')">
      <img src="../../assets/img/hld1.jpeg"/>
    </div>
    <div>
      <img src="../../assets/img/hld2.jpeg"/>
    </div> -->
  </div>
</template>
<script>
import img1 from "../../assets/img/undraw_Prototyping_process_re_7a6p.png";
import img2 from "../../assets/img/undraw_Target_re_fi8j.png";
import img3 from "../../assets/img/undraw_Control_panel_re_y3ar.png";
import img4 from "../../assets/img/undraw_Grades_re_j7d6.png";
import Map from './components/map.vue'
export default {
  data() {
    return {
      cardData: [
        {
          imgsrc: img1,
          title: "高中课程学习与专业选择互适应系统",
          desc: "在高中课程学习与专业选择的互适应系统中，总体目标是通过个性测评和科目推荐两者结果的结合推荐出学生高考的选考科目。并在最终的高考志愿填报中以个性测评所得的专业为向导选择相关院校，实现高中生的学涯规划。",
          url: '/m-index/adaptation'
        },
        {
          imgsrc: img2,
          title: "个性化高考志愿填报智能推荐系统",
          desc: "本系统记录有至少近3年湖北省各批次的一分一段表、当年各高校专业在湖北省内的招生信息以及各高校当年最新公布的招生简章信息。运用科学的志愿填报方法、基于院校历史录取数据，为考生和家长提供一套操作简单、结果科学的志愿填报参考系统，大幅提升家长和考生志愿填报决策的科学性和准确性",
          url: "/recommend/index"
        },
        {
          imgsrc: img3,
          title: "高校专业布局与招生指标优化配置系统",
          desc: '通过对高校专业进行事件画像，便于高校主管部门对相关专业有直观的全面的整体的认识;再通过关联、聚类、预测等模型绘制出相关专业发展的动态趋势图，为高校主管部门就专业规划、专业评估、招生指标分配及后期调整等提供决策参考。',
          url: "/configuration",
        },
        {
          imgsrc: img4,
          title: "高校学生就业形势分析与预测系统",
          desc: "从就业率、薪资水平、就业结构、毕业生供需比、社会认可度等方面，为高校专业布局以及指标分配优化提供依据，实现面向专业的高校毕业生就业风险评估。同时提供各学科门类、专业类别、专业的整体就业难度指数、整体就业率，通过系统可以查询就业指标数据、热门专业推荐、就业率排行榜等。",
          url: "/forecast"
        },
      ],
    };
  },
  components: {
    Map
  },
  methods: {
    goToFn(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style lang="less" scoped>
.m-main {
  .m-main-bg {
    background: #101724;
    width: 100%;
    height: 400px;
    position: relative;
    .descript {
      position: absolute;
      left: 15%;
      color: #ffffff;
      max-width: 590px;
      padding-top: 49px;
      .fs-50 {
        font-size: 70px;
        font-weight: bold;
        font-family: cursive;
        line-height: 70px;
      }
      .padding-left {
        padding-left: 148px;
        margin-top: 20px;
      }
      .fs-20 {
        margin-top: 30px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
      }
    }
    &-img {
      width: 400px;
      margin: 0 auto;
      margin-bottom: 20px;
      position: absolute;
      right: 15%;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .card-contain {

    display: flex;
    justify-content: center;
    padding: 50px 8% 0;
    margin-top: -20px;
    margin-bottom: 20px;
    >div {
      border: 1px solid #e7ebf0;
      border-radius: 10px;
      max-width: 320px;
      width: 20%;
      background: #ffffff;
      height: 420px;
      .img {
        width: 100%;
        height: 200px;
        border-radius: 10px 10px 0 0;
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 10px 10px 0 0;
        }
      }
      .title {
        // text-align: center;
        padding: 20px 20px 0; 
        font-size: 16px;
        font-weight: bolder;
      }
      .desc {
        font-size: 12px;
        color: #6f6f79;
        padding: 0px 20px 10px;
      }
      
    }
    .card-contain__item {
      cursor: pointer;
    }
    .card-contain__item:hover {
      box-shadow: -2px 0px 5px 1px #e7ebf0,0px -2px 5px 1px #e7ebf0,2px 0px 5px 1px #e7ebf0,0px 2px 5px 1px #e7ebf0;
    }
    .card-contain__item + .card-contain__item {
        margin-left:20px;
      }
    
  }
  .card-contain + .card-contain {
    margin-left: 20px;
  }
  // >div {
  //   width: 36%;
  //   height: 300px;
  //   margin-right: 50px;
  //   border-radius: 20px;
  //   img {
  //     width: 100%;
  //     height: 100%;
  //     display: block;
  //     border-radius: 20px;
  //   }
  // }
  // >div:nth-child(2) {
  //   margin-right: 0;
  // }
}
</style>